const selectors = {
  revealer: '[data-comp-section-sub-models-revealer]',
};

export { selectors };
